import { render, staticRenderFns } from "./WsActAddStepDialog.vue?vue&type=template&id=6b27a726&"
import script from "./WsActAddStepDialog.vue?vue&type=script&lang=js&"
export * from "./WsActAddStepDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports